/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Sprout = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M1.20129 1.6801L1.3347 1L2.2689 1.10782C6.90784 1.70693 10.6485 4.98705 11.9782 9.29109L12.037 9.49047L12.0617 9.4398C13.6168 6.29915 16.8144 4.11637 20.5316 4.01421L20.8045 4.01046C21.153 4.01046 21.4954 4.02877 21.8319 4.06574L22.5734 4.14721L22.4959 4.88915C21.9513 10.1046 17.7045 14.1542 12.5009 14.4882L12.5 23.0105H11V14.508L10.885 14.5052L10.888 14.4755L10.6159 14.4514C5.30512 13.8945 1.14559 9.47089 1.00374 4.04685L1 3.76046C1 3.05645 1.06778 2.3607 1.20129 1.6801ZM2.563 2.67047C2.52101 3.03496 2.5 3.39629 2.5 3.76046C2.5 8.5106 6.08052 12.4245 10.6899 12.9504L10.996 12.9795L11 12.7605C11 7.78117 7.42909 3.56812 2.63476 2.6826L2.563 2.67047ZM20.8045 5.51046C16.5857 5.51046 13.1065 8.67718 12.6142 12.7633L12.591 12.9765L12.6026 12.9764C16.7256 12.6228 20.1131 9.55514 20.8881 5.51786L20.8045 5.51046Z"
                        fill={color}
                    />
                </svg>
        );
    };
